import {useQuery} from "@tanstack/react-query";
import {GetDiscountCodeApiResponse} from "../types";
import {AxiosError} from "axios";
import {useClient} from "../../../../utils/hooks";
import {normalizeV2DiscountDetail} from "../../../../react-query-hooks/discounts/discount-normalizer";

export const useGetDiscountCode = (codeId?: string) => {
  const client = useClient("DISCOUNTS");

  return useQuery<
    GetDiscountCodeApiResponse,
    AxiosError<{status: boolean; message: string}>
  >({
    queryKey: ["get_discount_code", String(codeId)],
    queryFn: async () => {
      const data = await client(`discounts/${codeId}`);
      const payload = data?.data ?? data;
      return normalizeV2DiscountDetail(payload);
    },
    enabled: !!codeId,
    refetchOnWindowFocus: false,
  });
};
